import { CustomURLEncoder } from './custom-url-encoder';
import { ParentService } from './parent.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SettingService } from './setting.service';
import { left } from '@popperjs/core';
import { BaseService } from './base.service';
declare const encryptValueCustom: any;

@Injectable({
  providedIn: 'root',
})
export class LoginService extends BaseService {
  public isBiometricsDone;
  public validOption;
  constructor(protected http: HttpClient, public settingService: SettingService) {
    // this.settingService.load();
    super(http, settingService, 'LOGIN');
    this.isBiometricsDone = false;
    this.id = 0;
  }

  /**
   * This will initialize and load languages
   * @returns JSON Object to load language list
   */
  public init(): Observable<Object> {
    return this.httpGet(`/api/labels/getAllLanguages`);
    // return this.httpGet(`${this.settingService.getURLValue('LABEL')}/getAllLanguages`);
    // return this.httpGet(`${this.settingService.baseURL}/labels/getAllLanguages`);
  }

  // public init(): Observable<Object> {
  //   this.httpGet(`/api/labels/getAllLanguages`).subscribe(
  //     (languageList): any => {
  //       this.validOption = languageList['data'].validOption;
  //     },
  //     (error) => {
  //       console.log('All Language list loading failed.');
  //       console.log('Error:', error);
  //       this.settingService.message = 'Please check your connection';
  //       this.handleError(error);
  //     }
  //   );
  //   return this.httpGet(`/api/labels/getAllLanguages`);
  //   // return this.httpGet(`${this.settingService.getURLValue('LABEL')}/getAllLanguages`);
  //   // return this.httpGet(`${this.settingService.baseURL}/labels/getAllLanguages`);
  // }

  public load(id: any, modelNameList: string[], isMetadataReqd?: boolean): Observable<Object> {
    return;
  }
  public process(id: any, modelNameList: string[]): Observable<Object> {
    return;
  }
  public find(executeSearch?: boolean, searchCriteriaData?: any): Observable<Object> {
    return;
  }

  /**
   *
   * @param id expects login User ID
   * @param password expects Login User Password
   * @param language expects Language
   * this method is used to call validate login.
   */
  public processLogin(
    userId: string,
    password: string,
    language: string,
    token?: string,
    useCase?: string
  ): Observable<Object> {
    if (this.settingService.getApplicationMode() === 'offline') {
      return this.loginOffline(userId, password, language);
    } else {
      return this.loginOnline(userId, password, language, token, useCase);
    }
  }

  /**
   * @ignore
   */
  private loginOffline(userId: string, password: string, language: string) {
    let encryptPassword = password;
    if (this.isBiometricsDone == undefined || this.isBiometricsDone != true) {
      encryptPassword = this.encryptPassword(password);
    }

    let body = {
      userId: userId,
      regPass: encryptPassword,
      language: language,
    };
    return this.httpPost(`${this.settingService.getURLValue('LOGIN')}/login`, body);
  }

  /**
   * @ignore
   */

  private loginOnline(userId: string, password: string, language: string, token?: string, useCase?: string) {
    //console.log('Password-', password);
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
    };
    if (token != undefined) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Auth-Token': token,
        }),
      };
    }
    httpOptions.headers = this.settingService.addCustomHeaders(httpOptions.headers);
    let httpParam = new HttpParams({ encoder: new CustomURLEncoder() })
      .set('userId', userId)
      .set('password', this.encryptPassword(password))
      .set('enc', 'YES')
      .set('login_type', 'AGENT')
      .set('language', language);
    if (useCase != undefined && useCase != '') {
      Object.assign(httpParam, httpParam.append('useCase', useCase));
    }
    //console.log('httpParam-', httpParam);
    // return this.http.post(`${this.settingService.getURLValue('LOGIN')}`, httpParam, httpOptions);
    return this.http.post(`${this.settingService.baseURL}login`, httpParam, httpOptions);
  }
  /**
   *
   * @param newPassword expects new password to set
   * @param confirmPassword expects same passowrd entered in the new password from the user
   * @param oldPassword expects the old password
   * @returns
   */
  public changePassword(newPassword: string, confirmPassword: string, oldPassword: string) {
    let params = {
      confirmPassword: this.encryptText(confirmPassword),
      password: this.encryptText(newPassword),
      oldPassword: this.encryptText(oldPassword),
    };

    return this.httpPost(`${this.settingService.getURLValue('PASSWORD')}/change`, params, undefined, true);
  }

  /**
   * Set the login details in session based on the parameter passed
   * @param userDetails expects userdetail JSON with its properties.
   * @param userId expects user id from login. It's a optional parameter.
   * @param language expects the language if any. It's a optional parameter.
   */
  public setLoginUserDetails(userDetails: any, userId?: any, language?: any) {
    if (userId != undefined) {
      this.settingService.setSessionStorageValue('USER', JSON.stringify(JSON.parse(JSON.stringify(userId))));
      this.settingService.setSessionStorageValue('language', language);
      this.settingService.setSessionStorageValue('UserImage', userDetails.data.userLoginData.UserImage);
      this.settingService.setSessionStorageValue('UserImageName', userDetails.data.userLoginData.UserImageName);
    } else {
      this.settingService.setSessionStorageValue('USER', JSON.stringify(userDetails.data.UserId));
      this.settingService.setSessionStorageValue('language', userDetails.data.Language);
    }

    // this.settingService.getLabelValue(language);
    // console.log(this.settingService.applicationProperties)
    /**commented for committing v16 */
    // userDetails.data.ApplicationProperties['CALENDARLANG'] = 'zh-Hans';
    SettingService.applicationProperties = userDetails.data.ApplicationProperties;
    if (userDetails.data.Token && userDetails.data.Token != undefined) {
      this.settingService.setSessionStorageValue('Token', userDetails.data.Token);
    }

    this.settingService.setSessionStorageValue(
      'applicationProperties',
      JSON.stringify(JSON.parse(JSON.stringify(SettingService.applicationProperties)))
    );

    if (userDetails.data.userType != undefined) {
      this.settingService.setSessionStorageValue('userType', userDetails.data.userType);
    }
    if (userDetails.data.userLoginData != undefined) {
      this.settingService.setSessionStorageValue('userLoginData', JSON.stringify(userDetails.data.userLoginData));
    }
    this.settingService.setSessionStorageValue('firstReloadURL', false);
    this.settingService.setSessionStorageValue('BatchDate', userDetails.data.BatchDate);

    // SettingService.applicationProperties['CALENDARLANG'] = 'zh-Hans';
    this.settingService.load();
  }

  /**
   * This encrypts and generate the otp for the user.
   * @param guid expects the encrypted guid
   */
  public getEncryptOTP(guid: string, isResendOtp: boolean): Observable<Object> {
    let body = {};

    if (isResendOtp != undefined) {
      body = {
        guid: guid,
        isResendOtp: isResendOtp,
      };
    } else {
      body = {
        guid: guid,
      };
    }
    // return this.httpPost(`${this.settingService.getURLValue('LOGIN')}/encryptotp`, body, undefined, true);
    return this.httpPost(`api/login/encryptotp`, body, undefined, true);
  }

  /**
   * Get label value of specific label keys
   * @param labelKeyList .list of label keys
   */
  public getLabels(labelKeyList: any): Observable<Object> {
    let body = {
      labelKeyList: labelKeyList,
    };

    return this.httpPost(`${this.settingService.baseURL}login/getLabels`, body, undefined, true, undefined);

    // return this.httpPost(`${this.settingService.getURLValue('LOGIN')}/getLabels`, body, undefined, true);
    // return this.httpPost(`${this.settingService.baseURL}/login/getLabels`, body, undefined, true);
  }

  /**
   * Get lookup data list of specific lookup keys
   * @param lookupKeyList .list of label keys
   */
  public getLookupData(lookupKeyList: any): Observable<Object> {
    let body = {
      lookupKeyList: lookupKeyList,
    };
    return this.httpPost(`${this.settingService.getURLValue('LABEL')}/getLookupData`, body, undefined, true);
  }

  /**
   *
   * @param otpGuid
   * @param otp
   * @param otpType
   * @returns
   */
  public validateLoginOTP(otpGuid: any, otp: any, otpType: any) {
    let params = new HttpParams({
      fromObject: {
        otpGuid: otpGuid,
        otp: this.encryptPassword(otp),
        otpType: otpType,
      },
    });
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
    };
    httpOptions.headers = this.settingService.addCustomHeaders(httpOptions.headers);
    // return this.http.post(`${this.settingService.getURLValue('LOGIN')}/validateOTP`, params, httpOptions);
    return this.http.post(`api/login/validateOTP`, params, httpOptions);
  }

  /**
   * This fetches the Recipient Data of the user.
   * @param guid expects the encrypted guid
   */
  public getOTPRecipientData(guid: string): Observable<Object> {
    let body = {
      guid: guid,
    };
    return this.httpPost(`api/login/getOTPRecipientData`, body, undefined, true);
  }
  public encryptPassword(text: string): string {
    let encryptedText = CryptoJS.AES.encrypt(text, this.validOption);
    return encryptedText.toString();
  }
}
